import { Box, Grid, Stack, Typography, Card } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { grey } from '@mui/material/colors';
import { getStaticLegal } from '../../../redux/slices/common'
import { useDispatch } from 'react-redux'
import NoDataFound from 'common/component/NoDataFound'
import Loader from 'common/Loader'
import StatusText from 'common/component/StatusText';

const EditLegalPagesDetails = ({ legalId, dataProps, fullRoleTabSlug }) => {
    const dispatch = useDispatch()
    const { singleLegal = {}, isLoading = false } = useSelector(state => state.common);
    const [searchParams, setSearchParams] = useSearchParams();
    const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
    const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);
    const [nodataFound, setNodataFound] = useState(false)
    const [formData, setFormData] = useState({
        status: true,
        'faq': {
            "status": true,
            "section": [
            ]
        },
        heading: '',
        metaDescription: '',
        "metaProperties": {
            "title": "",
            "description": "",
        },
        "displaySettings": {
            "hamburgerMenu": true,
            "footer": true
        },
    });

    useEffect(() => {
        dispatch(getStaticLegal({ id: fullRoleTabheading, platform: fullRoleTab })).unwrap().then((res) => {
            const data = res?.legalDetails
            setFormData({
                status: data?.status,
                faq: data?.faq?.section,
                heading: data?.heading,
                contentHeading: data?.contentHeading,
                "metaProperties": {
                    "title": data?.metaProperties?.title,
                    "description": data?.metaProperties?.description,
                },
                description: data?.description,
                "displaySettings": {
                    "hamburgerMenu": data?.displaySettings?.hamburgerMenu,
                    "footer": data?.displaySettings?.footer
                },
            })
            setNodataFound(false)
        }).catch((err) => {
            setNodataFound(true)
        });
    }, [fullRoleTabheading, fullRoleTab]);


    return (
        <>
            {
                isLoading ?
                    <Loader /> :
                    <>
                        {
                            nodataFound ? <NoDataFound /> :
                                <Box p={4} pt={2} className="static-pages-container">

                                    {/***************** Page Title *****************/}
                                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                                            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                                                {fullRoleTabheading}
                                            </Typography>
                                            <StatusText status={singleLegal?.status ? "active" : "inactive"} />

                                        </Stack>
                                    </Card>

                                    {/********************** Select Platform/Show On **********************/}
                                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                                        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2}>
                                <Typography variant='h5' fontWeight="semibold">Selected Platforms</Typography>
                            </Stack>

                            <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                                <Grid item xs={12}>
                                    <Stack direction="row" alignItems="center" spacing={3}>
                                        {singleLegal?.platformAvailability?.hyperwolf && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>{"Hyperwolf"}</badge>}
                                        {singleLegal?.platformAvailability?.hemp && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hemp</badge>}
                                    </Stack>
                                </Grid>
                            </Grid> */}

                                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2} mt={2}>
                                            <Typography variant='h5' fontWeight="semibold">Visible On</Typography>
                                        </Stack>

                                        <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                                            <Grid item xs={12}>
                                                <Stack direction="row" alignItems="center" spacing={3}>
                                                    {singleLegal?.displaySettings?.footer && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Footer</badge>}
                                                    {singleLegal?.displaySettings?.hamburgerMenu && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hamburger Menu</badge>}
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Card>

                                    {/********************** Meta Tags **********************/}
                                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                                            <Typography variant='h5' fontWeight="semibold">Meta Properties</Typography>
                                        </Stack>

                                        <Grid container alignItems="center" spacing={3} mb={2}>
                                            <Grid item xs={12}>
                                                <Typography variant='body2' color={grey[600]} mb={1}>Meta Title</Typography>
                                                <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.title ? singleLegal?.metaProperties?.title : "-"}</Typography>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                                                <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.description ? singleLegal?.metaProperties?.description : "-"}</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography variant='body2' color={grey[600]} mb={1}>Updated By</Typography>
                                                <Typography variant='h5' fontWeight="medium">{singleLegal?.createdBy ? singleLegal?.createdBy : "-"}</Typography>
                                            </Grid>

                                        </Grid>
                                    </Card>


                                    {/********************** Contents Section **********************/}
                                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                                        <Typography variant='h5' fontWeight="semibold" mb={2}>Content Section</Typography>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                                <Typography variant='body2' fontWeight="medium" color={grey[600]} mb={1}>Page Heading</Typography>
                                                <Typography variant='h5' fontWeight="medium">
                                                    {formData?.contentHeading ? formData?.contentHeading : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography variant='body2' fontWeight='medium' color={grey[600]} mb={1}>Description</Typography>
                                                <Typography
                                                    variant="h5"
                                                    fontWeight="medium"
                                                    dangerouslySetInnerHTML={{
                                                        __html: formData?.description || "-",
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>

                                    {/********************** FAQ **********************/}

                                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                                            <Typography variant='h5' fontWeight="semibold">FAQs</Typography>
                                        </Stack>
                                        {
                                            singleLegal?.faq?.status && <>
                                                {
                                                    singleLegal?.faq?.section?.length !== 0 ?

                                                        <Grid container alignItems="center">
                                                            {
                                                                singleLegal?.faq?.section?.map((data) => {
                                                                    return (
                                                                        <Grid item xs={12} mb={2} key={data.answer}>
                                                                            <Typography
                                                                                variant="h5"
                                                                                fontWeight="medium"
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: data?.question || "-",
                                                                                }}
                                                                            />
                                                                            <Typography
                                                                                variant="body2"
                                                                                color={grey[600]}
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: data?.answer || "-",
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                    )
                                                                })
                                                            }
                                                        </Grid>
                                                        : <NoDataFound />
                                                }
                                            </>
                                        }
                                    </Card>
                                </Box>
                        }
                    </>
            }
        </>
    )
}

export default EditLegalPagesDetails